import { ApolloError, MutationResult } from '@apollo/client';

export enum PREFERENCE_KEYS {
  THEME = 'THEME',
  BOOKMARKS = 'BOOKMARKS',
  SIGNS_TABLE_COLUMNS = 'SIGNS_TABLE_COLUMNS',
  SIGNS_ACTIVITY_LOG_TABLE_COLUMNS = 'SIGNS_ACTIVITY_LOG_TABLE_COLUMNS',
  NOTIFICATION_POP_OUT = 'NOTIFICATION_POP_OUT',
  NOTIFICATION_LIST = 'NOTIFICATION_LIST',
  NOTIFICATION_TABLE_FILTERS = 'NOTIFICATION_TABLE_FILTERS',
  DISPLAY_TYPES_TABLE_COLUMNS = 'DISPLAY_TYPES_TABLE_COLUMNS',
  INTEGRATIONS_TABLE_COLUMNS = 'INTEGRATIONS_TABLE_COLUMNS',
  INTEGRATIONS_GROUPS_TABLE_COLUMNS = 'INTEGRATIONS_GROUPS_TABLE_COLUMNS',
  INTEGRATION_ACTIVITY_COLUMNS = 'INTEGRATION_ACTIVITY_COLUMNS',
  INTEGRATION_ACTIVITY_FILTERS = 'INTEGRATION_ACTIVITY_FILTERS',
  MESSAGE_LIBRARY_TABLE_COLUMNS = 'MESSAGE_LIBRARY_TABLE_COLUMNS',
  ROUTES_TABLE_COLUMNS = 'ROUTES_TABLE_COLUMNS',
  EVENT_TEMPLATES_TABLE_COLUMNS = 'EVENT_TEMPLATES_TABLE_COLUMNS',
  EVENT_MANAGEMENT_TABLE_COLUMNS = 'EVENT_MANAGEMENT_TABLE_COLUMNS',
  EVENT_PLANNING_TABLE_COLUMNS = 'EVENT_PLANNING_TABLE_COLUMNS',
  EVENT_SIGN_RULE_TABLE_COLUMNS = 'EVENT_SIGN_RULE_TABLE_COLUMNS',
  EVENT_TEMPLATE_TABLE_COLUMNS = 'EVENT_TEMPLATE_TABLE_COLUMNS',
  EVENT_ALARMS_TABLE_COLUMNS = 'EVENT_ALARMS_TABLE_COLUMNS',
  EVENT_ALARMS_TABLE_FILTERS = 'EVENT_ALARMS_TABLE_FILTERS',
  EVENT_ALARM_CONFIGS_TABLE_COLUMNS = 'EVENT_ALARM_CONFIGS_TABLE_COLUMNS',
  EVENT_ALARM_CONFIGS_TABLE_FILTERS = 'EVENT_ALARM_CONFIGS_TABLE_FILTERS',
  EVENT_RECOMMENDED_CONTACTS_TABLE_COLUMNS = 'EVENT_RECOMMENDED_CONTACTS_TABLE_COLUMNS',
  EVENT_RECOMMENDED_CONTACTS_TABLE_FILTERS = 'EVENT_RECOMMENDED_CONTACTS_TABLE_FILTERS',
  EXTERNAL_LINKS = 'EXTERNAL_LINKS',
  DETECTOR_ALARM_TABLE_COLUMNS = 'DETECTOR_ALARM_TABLE_COLUMNS',
  FLEET_VEHICLE_TABLE_COLUMNS = 'FLEET_VEHICLE_TABLE_COLUMNS',
  FLEET_VEHICLE_TABLE_FILTERS = 'FLEET_VEHICLE_TABLE_FILTERS',
  FLEET_DRIVER_TABLE_COLUMNS = 'FLEET_DRIVER_TABLE_COLUMNS',
  FLEET_DRIVER_TABLE_FILTERS = 'FLEET_DRIVER_TABLE_FILTERS',
  ROAD_ASSISTANCE_TABLE_COLUMNS = 'ROAD_ASSISTANCE_TABLE_COLUMNS',
  ROAD_ASSISTANCE_TABLE_FILTERS = 'ROAD_ASSISTANCE_TABLE_FILTERS',
  ROAD_ASSISTANCE_ROUTE_TABLE_COLUMNS = 'ROAD_ASSISTANCE_ROUTE_TABLE_COLUMNS',
  ROAD_ASSISTANCE_ROUTE_TABLE_FILTERS = 'ROAD_ASSISTANCE_ROUTE_TABLE_FILTERS',
  ROAD_CONDITION_EVENT_TABLE_COLUMNS = 'ROAD_CONDITION_EVENT_TABLE_COLUMNS',
  ROAD_CONDITION_EVENT_TABLE_FILTERS = 'ROAD_CONDITION_EVENT_TABLE_FILTERS',
  ROAD_ASSISTANCE_TABLE_VIEW = 'ROAD_ASSISTANCE_TABLE_VIEW',
  ROAD_ASSISTANCE_SHIFT_DISPATCH_COLUMNS = 'ROAD_ASSISTANCE_SHIFT_DISPATCH_COLUMNS',
  ROAD_ASSISTANCE_SHIFT_DISPATCH_FILTERS = 'ROAD_ASSISTANCE_SHIFT_DISPATCH_FILTERS',
  PARKING_AREA_TABLE_COLUMNS = 'PARKING_AREA_TABLE_COLUMNS',
  PARKING_AREA_TABLE_FILTERS = 'PARKING_AREA_TABLE_FILTERS',
  GATE_SYSTEM_ROUTE_TABLE_COLUMNS = 'GATE_SYSTEM_ROUTE_TABLE_COLUMNS',
  GATE_ALARMS_TABLE_COLUMNS = 'GATE_ALARMS_TABLE_COLUMNS',
  GATE_ALARMS_TABLE_FILTERS = 'GATE_ALARMS_TABLE_FILTERS',
  GATE_ALARM_CONFIGS_TABLE_COLUMNS = 'GATE_ALARM_CONFIGS_TABLE_COLUMNS',
  GATE_ALARM_CONFIGS_TABLE_FILTERS = 'GATE_ALARM_CONFIGS_TABLE_FILTERS',
  GATE_CONTROLLER_TABLE_COLUMNS = 'GATE_CONTROLLER_TABLE_COLUMNS',
  GATE_CONTROLLER_TABLE_FILTERS = 'GATE_CONTROLLER_TABLE_FILTERS',
  GATE_CONTROLLER_ACTIVITY_TABLE_COLUMNS = 'GATE_CONTROLLER_ACTIVITY_TABLE_COLUMNS',
  GATE_CONTROLLER_ACTIVITY_TABLE_FILTERS = 'GATE_CONTROLLER_ACTIVITY_TABLE_FILTERS',
  GATE_CONTROLLER_STATUS_TABLE_COLUMNS = 'GATE_CONTROLLER_STATUS_TABLE_COLUMNS',
  GATE_CONTROLLER_STATUS_TABLE_FILTERS = 'GATE_CONTROLLER_STATUS_TABLE_FILTERS',
  GATE_CONTROLLER_CAMERA_TABLE_COLUMNS = 'GATE_CONTROLLER_CAMERA_TABLE_COLUMNS',
  GATE_CONTROLLER_CAMERA_TABLE_FILTERS = 'GATE_CONTROLLER_CAMERA_TABLE_FILTERS',
  GATE_CONTROLLER_SIGN_TABLE_COLUMNS = 'GATE_CONTROLLER_SIGN_TABLE_COLUMNS',
  GATE_CONTROLLER_SIGN_TABLE_FILTERS = 'GATE_CONTROLLER_SIGN_TABLE_FILTERS',
  GATE_OPERATION_RESOURCE_PLAN_TABLE_COLUMNS = ' GATE_OPERATION_RESOURCE_PLAN_TABLE_COLUMNS',
  GATE_OPERATION_RESOURCE_PLAN_TABLE_FILTERS = ' GATE_OPERATION_RESOURCE_PLAN_TABLE_FILTERS',
  GATE_SIGN_MESSAGE_TABLE_COLUMNS = 'GATE_SIGN_MESSAGE_TABLE_COLUMNS',
  GATE_SIGN_MESSAGE_TABLE_FILTERS = 'GATE_SIGN_MESSAGE_TABLE_FILTERS',
  GATE_GROUP_TABLE_COLUMNS = 'GATE_GROUP_TABLE_COLUMNS',
  GATE_GROUP_TABLE_FILTERS = 'GATE_GROUP_TABLE_FILTERS',
  GATE_SYSTEM_TABLE_COLUMNS = 'GATE_SYSTEM_TABLE_COLUMNS',
  GATE_SYSTEM_TABLE_FILTERS = 'GATE_SYSTEM_TABLE_FILTERS',
  GATE_TOLL_POINTS_TABLE_FILTERS = 'GATE_TOLL_POINTS_TABLE_FILTERS',
  GATE_TOLL_POINTS_TABLE_COLUMNS = 'GATE_TOLL_POINTS_TABLE_COLUMNS',
  GATE_SYSTEM_ACTIVITY_TABLE_COLUMNS = 'GATE_SYSTEM_ACTIVITY_TABLE_COLUMNS',
  GATE_SYSTEM_ACTIVITY_TABLE_FILTERS = 'GATE_SYSTEM_ACTIVITY_TABLE_FILTERS',
  GATE_SYSTEM_CONTROLLER_TABLE_COLUMNS = 'GATE_SYSTEM_CONTROLLER_TABLE_COLUMNS',
  GATE_SYSTEM_CONTROLLER_TABLE_FILTERS = 'GATE_SYSTEM_CONTROLLER_TABLE_FILTERS',
  GATE_CONTROLLER_ARM_TABLE_COLUMNS = 'GATE_CONTROLLER_ARM_TABLE_COLUMNS',
  GATES_ACTIVITY_LOG_TABLE_COLUMNS = 'GATES_ACTIVITY_LOG_TABLE_COLUMNS',
  GATES_ACTIVITY_LOG_TABLE_FILTERS = 'GATES_ACTIVITY_LOG_TABLE_FILTERS',
  GATE_OPERATION_HISTORY_TABLE_COLUMNS = 'GATE_OPERATION_HISTORY_TABLE_COLUMNS',
  GATE_OPERATION_HISTORY_TABLE_FILTERS = 'GATE_OPERATION_HISTORY_TABLE_FILTERS',
  GATE_OPERATION_ACTIVITY_TABLE_COLUMNS = 'GATE_OPERATION_ACTIVITY_TABLE_COLUMNS',
  GATE_OPERATION_ACTIVITY_TABLE_FILTERS = 'GATE_OPERATION_ACTIVITY_TABLE_FILTERS',
  CORRIDOR_CONFIG_TUNNEL_LIGHT_TABLE_COLUMNS = 'CORRIDOR_CONFIG_TUNNEL_LIGHT_TABLE_COLUMNS',
  CORRIDOR_CONFIG_TUNNEL_LIGHT_TABLE_FILTERS = 'CORRIDOR_CONFIG_TUNNEL_LIGHT_TABLE_FILTERS',
  CORRIDOR_CONFIG_TUNNEL_LIGHT_SELECT_TABLE_COLUMNS = 'CORRIDOR_CONFIG_TUNNEL_LIGHT_SELECT_TABLE_COLUMNS',
  CORRIDOR_CONFIG_TUNNEL_LIGHT_SELECT_TABLE_FILTERS = 'CORRIDOR_CONFIG_TUNNEL_LIGHT_SELECT_TABLE_FILTERS',
  CORRIDOR_DEFAULT_LAYERS = 'CORRIDOR_DEFAULT_LAYERS',
  CORRIDOR_ALARMS_TABLE_COLUMNS = 'CORRIDOR_ALARMS_TABLE_COLUMNS',
  CORRIDOR_ALARMS_TABLE_FILTERS = 'CORRIDOR_ALARMS_TABLE_FILTERS',
  CORRIDOR_WEATHER_TABLE_COLUMNS = 'CORRIDOR_WEATHER_TABLE_COLUMNS',
  CORRIDOR_WEATHER_TABLE_FILTERS = 'CORRIDOR_WEATHER_TABLE_FILTERS',
  CORRIDOR_DETECTION_TABLE_COLUMNS = 'CORRIDOR_DETECTION_TABLE_COLUMNS',
  CORRIDOR_DETECTION_TABLE_FILTERS = 'CORRIDOR_DETECTION_TABLE_FILTERS',
  CORRIDOR_TABLE_COLUMNS = 'CORRIDOR_TABLE_COLUMNS',
  CORRIDOR_TABLE_FILTERS = 'CORRIDOR_TABLE_FILTERS',
  CORRIDOR_DOCUMENTS_TABLE_FILTERS = 'CORRIDOR_DOCUMENTS_TABLE_FILTERS',
  CORRIDOR_DOCUMENTS_TABLE_COLUMNS = 'CORRIDOR_DOCUMENTS_TABLE_COLUMNS',
  CORRIDOR_EVENT_TABLE_COLUMNS = 'CORRIDOR_EVENT_TABLE_COLUMNS',
  CORRIDOR_EVENT_TABLE_FILTERS = 'CORRIDOR_EVENT_TABLE_FILTERS',
  CORRIDOR_CAMERA_TABLE_FILTERS = 'CORRIDOR_CAMERA_TABLE_FILTERS',
  CORRIDOR_CAMERA_TABLE_COLUMNS = 'CORRIDOR_CAMERA_TABLE_COLUMNS',
  CORRIDOR_TOLL_POINT_SELECTION_TABLE_FILTERS = 'CORRIDOR_TOLL_POINT_SELECTION_TABLE_FILTERS',
  CORRIDOR_TOLL_POINT_SELECTION_TABLE_COLUMNS = 'CORRIDOR_TOLL_POINT_SELECTION_TABLE_COLUMNS',
  CORRIDOR_TRAVEL_TIME_TABLE_COLUMNS = 'CORRIDOR_TRAVEL_TIME_TABLE_COLUMNS',
  CORRIDOR_TRAVEL_TIME_TABLE_FILTERS = 'CORRIDOR_TRAVEL_TIME_TABLE_FILTERS',
  CORRIDOR_DETECTOR_TABLE_COLUMNS = 'CORRIDOR_DETECTOR_TABLE_COLUMNS',
  CORRIDOR_DETECTOR_TABLE_FILTERS = 'CORRIDOR_DETECTOR_TABLE_FILTERS',
  CORRIDOR_GATE_TABLE_COLUMNS = 'CORRIDOR_GATE_TABLE_COLUMNS',
  CORRIDOR_GATE_TABLE_FILTERS = 'CORRIDOR_GATE_TABLE_FILTERS',
  CORRIDOR_RULES_TABLE_COLUMNS = 'CORRIDOR_RULES_TABLE_COLUMNS',
  CORRIDOR_RULES_TABLE_FILTERS = 'CORRIDOR_RULES_TABLE_FILTERS',
  CORRIDOR_SIGN_TABLE_COLUMNS = 'CORRIDOR_SIGN_TABLE_COLUMNS',
  CORRIDOR_SIGN_TABLE_FILTERS = 'CORRIDOR_SIGN_TABLE_FILTERS',
  CORRIDOR_VSL_TABLE_COLUMNS = 'CORRIDOR_VSL_TABLE_COLUMNS',
  CORRIDOR_VSL_TABLE_FILTERS = 'CORRIDOR_VSL_TABLE_FILTERS',
  CORRIDOR_LCS_TABLE_COLUMNS = 'CORRIDOR_LCS_TABLE_COLUMNS',
  CORRIDOR_LCS_TABLE_FILTERS = 'CORRIDOR_LCS_TABLE_FILTERS',
  CORRIDOR_SCHEMATIC_TUNNEL_LIGHT_TABLE_COLUMNS = 'CORRIDOR_SCHEMATIC_TUNNEL_LIGHT_TABLE_COLUMNS',
  CORRIDOR_TUNNEL_FAN_TABLE_COLUMNS = 'CORRIDOR_TUNNEL_FAN_TABLE_COLUMNS',
  CORRIDOR_TUNNEL_FAN_TABLE_FILTERS = 'CORRIDOR_TUNNEL_FAN_TABLE_FILTERS',
  CORRIDOR_TUNNEL_LIGHT_TABLE_COLUMNS = 'CORRIDOR_TUNNEL_LIGHT_TABLE_COLUMNS',
  CORRIDOR_TUNNEL_LIGHT_TABLE_FILTERS = 'CORRIDOR_TUNNEL_LIGHT_TABLE_FILTERS',
  CORRIDOR_LANE_TABLE_FILTERS = 'CORRIDOR_LANE_TABLE_FILTERS',
  CORRIDOR_ZONES_TABLE_FILTERS = 'CORRIDOR_ZONES_TABLE_FILTERS',
  CORRIDOR_SCHEMATIC_SIGNS_TABLE_FILTERS = 'CORRIDOR_SCHEMATIC_SIGNS_TABLE_FILTERS',
  CORRIDOR_CAMERAS_TABLE_FILTERS = 'CORRIDOR_CAMERAS_TABLE_FILTERS',
  CORRIDOR_DEVICES_DETECTORS_TABLE_COLUMNS = 'CORRIDOR_DEVICES_DETECTORS_TABLE_COLUMNS',
  CORRIDOR_SCHEMATIC_VSL_TABLE_FILTERS = 'CORRIDOR_SCHEMATIC_VSL_TABLE_FILTERS',
  CORRIDOR_SCHEMATIC_LCS_TABLE_FILTERS = 'CORRIDOR_SCHEMATIC_LCS_TABLE_FILTERS',
  CORRIDOR_LANE_TABLE_COLUMNS = 'CORRIDOR_LANE_TABLE_COLUMNS',
  CORRIDOR_ZONES_TABLE_COLUMNS = 'CORRIDOR_ZONES_TABLE_COLUMNS',
  CORRIDOR_SCHEMATIC_SIGNS_TABLE_COLUMNS = 'CORRIDOR_SCHEMATIC_SIGNS_TABLE_COLUMNS',
  CORRIDOR_SCHEMATIC_CAMERAS_TABLE_FILTERS = 'CORRIDOR_SCHEMATIC_CAMERAS_TABLE_FILTERS',
  CORRIDOR_SCHEMATIC_CAMERAS_TABLE_COLUMNS = 'CORRIDOR_SCHEMATIC_CAMERAS_TABLE_COLUMNS',
  CORRIDOR_SCHEMATIC_VSL_TABLE_COLUMNS = 'CORRIDOR_SCHEMATIC_VSL_TABLE_COLUMNS',
  CORRIDOR_SCHEMATIC_LANDMARKS_TABLE_COLUMNS = 'CORRIDOR_SCHEMATIC_LANDMARKS_TABLE_COLUMNS',
  CORRIDOR_SCHEMATIC_LCS_TABLE_COLUMNS = 'CORRIDOR_SCHEMATIC_LCS_TABLE_COLUMNS',
  CORRIDOR_SCHEMATIC_WEATHER_TABLE_FILTERS = 'CORRIDOR_SCHEMATIC_WEATHER_TABLE_FILTERS',
  CORRIDOR_SCHEMATIC_WEATHER_TABLE_COLUMNS = 'CORRIDOR_SCHEMATIC_WEATHER_TABLE_COLUMNS',
  CORRIDOR_SCHEMATIC_CUTOUTS_TABLE_COLUMNS = 'CORRIDOR_SCHEMATIC_CUTOUTS_TABLE_COLUMNS',
  CORRIDOR_SCHEMATIC_TUNNEL_FAN_TABLE_COLUMNS = 'CORRIDOR_SCHEMATIC_TUNNEL_FAN_TABLE_COLUMNS',
  CORRIDOR_SCHEMATIC_GATE_GROUPS_TABLE_COLUMNS = 'CORRIDOR_SCHEMATIC_GATE_GROUPS_TABLE_COLUMNS',
  CORRIDOR_SCHEMATIC_TOLL_POINTS_TABLE_COLUMNS = 'CORRIDOR_SCHEMATIC_TOLL_POINTS_TABLE_COLUMNS',
  CORRIDOR_PLANS_TABLE_COLUMNS = 'CORRIDOR_PLANS_TABLE_COLUMNS',
  CORRIDOR_OVERVIEW = 'CORRIDOR_OVERVIEW',
  SITE_TABLE_COLUMNS = 'SITE_TABLE_COLUMNS',
  CUTOUT_TABLE_COLUMNS = 'CUTOUT_TABLE_COLUMNS',
  DETECTOR_SITE_REALTIME_TABLE_COLUMNS = 'DETECTOR_SITE_REALTIME_TABLE_COLUMNS',
  DETECTOR_SITE_ACTIVITY_LOG_TABLE_COLUMNS = 'DETECTOR_SITE_ACTIVITY_LOG_TABLE_COLUMNS',
  DETECTOR_SITE_REALTIME_TABLE_FILTERS = 'DETECTOR_SITE_REALTIME_TABLE_FILTERS',
  SIGNS_MULTI_POST_COLUMNS = 'SIGNS_MULTI_POST_COLUMNS',
  SIGNS_ALARM_CONFIGS_TABLE_COLUMNS = 'SIGNS_ALARM_CONFIGS_TABLE_COLUMNS',
  SIGNS_ALARM_CONFIGS_TABLE_FILTERS = 'SIGNS_ALARM_CONFIGS_TABLE_FILTERS',
  TRAVEL_TIME_TABLE_COLUMNS = 'TRAVEL_TIME_TABLE_COLUMNS',
  TRAVEL_TIME_TABLE_FILTERS = 'TRAVEL_TIME_TABLE_FILTERS',
  INTERSECTIONS_TABLE_COLUMNS = 'INTERSECTIONS_TABLE_COLUMNS',
  INTERSECTIONS_TABLE_FILTERS = 'INTERSECTIONS_TABLE_FILTERS',
  LOCATIONS_TABLE_COLUMNS = 'LOCATIONS_TABLE_COLUMNS',
  LOCATIONS_TABLE_FILTERS = 'LOCATIONS_TABLE_FILTERS',
  LOCATION_DOCUMENTS_TABLE_COLUMNS = 'LOCATION_DOCUMENTS_TABLE_COLUMNS',
  LOCATION_DOCUMENTS_TABLE_FILTERS = 'LOCATION_DOCUMENTS_TABLE_FILTERS',
  GANTRY_TABLE_COLUMNS = 'GANTRY_TABLE_COLUMNS',
  SPEED_SETTINGS_TABLE_COLUMNS = 'SPEED_SETTINGS_TABLE_COLUMNS',
  WEATHER_HISTORY_TABLE_COLUMNS = 'WEATHER_HISTORY_TABLE_COLUMNS',
  WEATHER_HISTORY_TABLE_FILTERS = 'WEATHER_HISTORY_TABLE_FILTERS',
  WEATHER_STATION_TABLE_COLUMNS = 'WEATHER_STATION_TABLE_COLUMNS',
  SYSTEM_ROLES_TABLE_COLUMNS = 'SYSTEM_ROLES_TABLE_COLUMNS',
  SYSTEM_USER_GROUPS_TABLE_COLUMNS = 'SYSTEM_USER_GROUPS_TABLE_COLUMNS',
  SYSTEM_USERS_TABLE_COLUMNS = 'SYSTEM_USERS_TABLE_COLUMNS',
  SYSTEM_MAP_CONFIG_COLUMNS = 'SYSTEM_MAP_CONFIG_COLUMNS',
  SYSTEM_MAP_LAYER_CONFIG_COLUMNS = 'SYSTEM_MAP_LAYER_CONFIG_COLUMNS',
  LANE_CONTROL_SETTINGS_COLUMNS = 'LANE_CONTROL_SETTINGS_CONFIG_COLUMNS',
  SYSTEM_FORM_CONFIG_COLUMNS = 'SYSTEM_FORM_CONFIG_COLUMNS',
  CONTACTS_TABLE_COLUMNS = 'CONTACTS_TABLE_COLUMNS',
  CONTACT_GROUPS_TABLE_COLUMNS = 'CONTACT_GROUPS_TABLE_COLUMNS',
  ORGANIZATIONS_TABLE_COLUMNS = 'ORGANIZATIONS_TABLE_COLUMNS',
  REQUEST_ACTIVITY_LOG_TABLE_COLUMNS = 'REQUEST_ACTIVITY_LOG_TABLE_COLUMNS',
  EMAIL_REQUEST_ACTIVITY_LOG_TABLE_FILTERS = 'EMAIL_REQUEST_ACTIVITY_LOG_TABLE_FILTERS',
  RULE_ACTIVITY_LOG_TABLE_COLUMNS = 'RULE_ACTIVITY_LOG_TABLE_COLUMNS',
  EMAIL_RULE_ACTIVITY_LOG_TABLE_FILTERS = 'EMAIL_RULE_ACTIVITY_LOG_TABLE_FILTERS',
  EMAIL_RULE_ACTIVITY_LOG_TABLE_COLUMNS = 'EMAIL_RULE_ACTIVITY_LOG_TABLE_COLUMNS',
  DEFAULT_ORGANIZATION = 'DEFAULT_ORGANIZATION',
  EXTENT_LAYERS = 'EXTENT_LAYERS',
  WORKSPACES = 'WORKSPACES',
  SYSTEM_WORKSPACES = 'SYSTEM_WORKSPACES',
  DISMISS_NOTIFICATIONS = 'DISMISS_NOTIFICATIONS',
  DISABLE_DISMISS_NOTIFICATIONS = 'DISABLE_DISMISS_NOTIFICATIONS',
  EVENT_DASHBOARD_FILTERS = 'EVENT_DASHBOARD_FILTERS',
  EVENT_DASHBOARD = 'EVENT_DASHBOARD',
  UNIT = 'UNIT',
  CURRENCY = 'CURRENCY',
  DATE_FORMAT = 'DATE_FORMAT',
  TIME_FORMAT = 'TIME_FORMAT',
  DETECTOR_CONNECTION_LOG_TABLE_COLUMNS = 'DETECTOR_CONNECTION_LOG_TABLE_COLUMNS',
  RECORDINGS_TABLE_COLUMNS = 'RECORDINGS_TABLE_COLUMNS',
  ACTIVITY_LOG_TABLE_COLUMNS = 'ACTIVITY_LOG_TABLE_COLUMNS',
  INTEGRATIONS_TABLE_FILTERS = 'INTEGRATIONS_TABLE_FILTERS',
  ALARMS_TABLE_FILTERS = 'ALARMS_TABLE_FILTERS',
  DETECTORS_TABLE_FILTERS = 'DETECTORS_TABLE_FILTERS',
  CAMERAS_TABLE_FILTERS = 'CAMERAS_TABLE_FILTERS',
  RECORDINGS_TABLE_FILTERS = 'RECORDINGS_TABLE_FILTERS',
  ACTIVITY_LOG_TABLE_FILTERS = 'ACTIVITY_LOG_TABLE_FILTERS',
  WEATHER_STATION_TABLE_FILTERS = 'WEATHER_STATION_TABLE_FILTERS',
  EVENTS_PLANNING_TABLE_FILTERS = 'EVENTS_PLANNING_TABLE_FILTERS',
  EVENTS_MANAGEMENT_TABLE_FILTERS = 'EVENTS_MANAGEMENT_TABLE_FILTERS',
  EVENT_TEMPLATES_TABLE_FILTERS = 'EVENT_TEMPLATES_TABLE_FILTERS',
  CORRIDOR_LOG_TABLE_FILTERS = 'CORRIDOR_LOG_TABLE_FILTERS',
  CORRIDOR_LOG_TABLE_COLUMNS = 'CORRIDOR_LOG_TABLE_COLUMNS',
  EVENTS_DETECTION_TABLE_FILTERS = 'EVENTS_DETECTION_TABLE_FILTERS',
  EVENTS_DETECTION_TABLE_COLUMNS = 'EVENTS_DETECTION_TABLE_COLUMNS',
  EVENTS_DETECTION_TABLE_VIEW = 'EVENTS_DETECTION_TABLE_VIEW',
  EVENT_RULE_TABLE_FILTERS = 'EVENT_RULE_TABLE_FILTERS',
  SIGNALS_INTERSECTIONS_TABLE_FILTERS = 'SIGNALS_INTERSECTIONS_TABLE_FILTERS',
  SIGNS_TABLE_FILTERS = 'SIGNS_TABLE_FILTERS',
  MESSAGE_LIBRARY_TABLE_FILTERS = 'MESSAGE_LIBRARY_TABLE_FILTERS',
  CONTACTS_TABLE_FILTERS = 'CONTACTS_TABLE_FILTERS',
  TUNNEL_TABLE_COLUMNS = 'TUNNEL_TABLE_COLUMNS',
  TUNNEL_TABLE_FILTERS = 'TUNNEL_TABLE_FILTERS',
  TUNNEL_FAN_TABLE_COLUMNS = 'TUNNEL_FAN_TABLE_COLUMNS',
  TUNNEL_FAN_TABLE_FILTERS = 'TUNNEL_FAN_TABLE_FILTERS',
  TUNNEL_LOG_TABLE_COLUMNS = 'TUNNEL_LOG_TABLE_COLUMNS',
  TUNNEL_LOG_TABLE_FILTERS = 'TUNNEL_LOG_TABLE_FILTERS',
  RESOURCE_PLAN_TABLE_COLUMNS = 'RESOURCE_PLAN_TABLE_COLUMNS',
  RESOURCE_PLAN_TABLE_FILTERS = 'RESOURCE_PLAN_TABLE_FILTERS',
  RESOURCE_PLAN_SIGN_TABLE_COLUMNS = 'RESOURCE_PLAN_SIGN_TABLE_COLUMNS',
  RESOURCE_PLAN_SIGN_TABLE_FILTERS = 'RESOURCE_PLAN_SIGN_TABLE_FILTERS',
  RESOURCE_PLAN_SPEED_LIMIT_TABLE_COLUMNS = 'RESOURCE_PLAN_SPEED_LIMIT_TABLE_COLUMNS',
  RESOURCE_PLAN_SPEED_LIMIT_TABLE_FILTERS = 'RESOURCE_PLAN_SPEED_LIMIT_TABLE_FILTERS',
  RESOURCE_PLAN_LANE_CONTROL_TABLE_COLUMNS = 'RESOURCE_PLAN_LANE_CONTROL_TABLE_COLUMNS',
  RESOURCE_PLAN_LANE_CONTROL_TABLE_FILTERS = 'RESOURCE_PLAN_LANE_CONTROL_TABLE_FILTERS',
  FAILED_RESOURCE_PLAN_LIST_TABLE_FILTERS = 'FAILED_RESOURCE_PLAN_LIST_TABLE_FILTERS',
  FAILED_RESOURCE_PLAN_LIST_TABLE_COLUMNS = 'FAILED_RESOURCE_PLAN_LIST_TABLE_COLUMNS',
  WEATHER_ATMOSPHERIC_TABLE_COLUMNS = 'WEATHER_ATMOSPHERIC_TABLE_COLUMNS',
  WEATHER_ATMOSPHERIC_TABLE_FILTERS = 'WEATHER_ATMOSPHERIC_TABLE_FILTERS',
  WEATHER_PAVEMENT_TABLE_COLUMNS = 'WEATHER_PAVEMENT_TABLE_COLUMNS',
  WEATHER_PAVEMENT_TABLE_FILTERS = 'WEATHER_PAVEMENT_TABLE_FILTERS',
  WEATHER_SUBSURFACE_TABLE_COLUMNS = 'WEATHER_SUBSURFACE_TABLE_COLUMNS',
  WEATHER_SUBSURFACE_TABLE_FILTERS = 'WEATHER_SUBSURFACE_TABLE_FILTERS',
  EMAIL_RULES_TABLE_FILTERS = 'EMAIL_RULES_TABLE_FILTERS',
  EMAIL_RULES_TABLE_COLUMNS = 'EMAIL_RULES_TABLE_COLUMNS',
  CAMERA_ACTIVITY_LOG_TABLE_COLUMNS = 'CAMERA_ACTIVITY_LOG_TABLE_COLUMNS',
  CAMERA_ACTIVITY_LOG_TABLE_FILTERS = 'CAMERA_ACTIVITY_LOG_TABLE_FILTERS',
  COMMUNICATION_LOGS_TABLE_COLUMNS = 'CAMERA_ACTIVITY_LOG_TABLE_COLUMNS',
  COMMUNICATION_LOGS_TABLE_FILTERS = 'CAMERA_ACTIVITY_LOG_TABLE_FILTERS',
  MAP_STATUS_BAR = 'MAP_STATUS_BAR',
  VIDEO_WALL_DEFAULT_SCENE = 'VIDEO_WALL_DEFAULT_SCENE',
  PATROL_ROUTES_TABLE_FILTERS = 'PATROL_ROUTES_TABLE_FILTERS',
  MAP_CLUSTERING = 'MAP_CLUSTERING',
  MAP_ZOOM_BUTTONS = 'MAP_ZOOM_BUTTONS',
  VOLUME_WIDGET_TABLE_COLUMNS = 'VOLUME_WIDGET_TABLE_COLUMNS',
  VOLUME_WIDGET_TABLE_FILTERS = 'VOLUME_WIDGET_TABLE_FILTERS',
  EVENT_ACTIVITY_LOG_TABLE_COLUMNS = 'EVENT_ACTIVITY_LOG_TABLE_COLUMNS',
  EVENT_ACTIVITY_LOG_TABLE_FILTERS = 'EVENT_ACTIVITY_LOG_TABLE_FILTERS',
  DEVICE_EVENTS_TABLE_FILTERS = 'DEVICE_EVENTS_TABLE_FILTERS',
  DEVICE_EVENTS_TABLE_COLUMNS = 'DEVICE_EVENTS_TABLE_COLUMNS',
  APPLIED_COMMANDS_TABLE_FILTERS = 'APPLIED_COMMANDS_TABLE_FILTERS',
  APPLIED_COMMANDS_TABLE_COLUMNS = 'APPLIED_COMMANDS_TABLE_COLUMNS',
  COUNTS_RULES_TABLE_FILTERS = 'COUNTS_RULES_TABLE_FILTERS',
  COUNTS_ACTIVITY_LOG_TABLE_FILTERS = 'COUNTS_ACTIVITY_LOG_TABLE_FILTERS',
  COUNTS_ACTIVITY_LOG_TABLE_COLUMNS = 'COUNTS_ACTIVITY_LOG_TABLE_COLUMNS',
  COUNTS_SITE_ACTIVITY_LOG_TABLE_FILTERS = 'COUNTS_SITE_ACTIVITY_LOG_TABLE_FILTERS',
  COUNTS_SITE_ACTIVITY_LOG_TABLE_COLUMNS = 'COUNTS_SITE_ACTIVITY_LOG_TABLE_COLUMNS',
  COUNTS_SITE_GROUPS_TABLE_FILTERS = 'COUNTS_SITE_GROUPS_TABLE_FILTERS',
  COUNTS_SITES_TABLE_FILTERS = 'COUNTS_SITES_TABLE_FILTERS',
  COUNTS_TURNING_REPORT_TABLE_FILTERS = 'COUNTS_TURNING_REPORT_TABLE_FILTERS',
  COUNTS_VEHICLEGROSSCOUNTWEIGHT_WIDGET_TABLE_COLUMNS = 'COUNTS_VEHICLEGROSSCOUNTWEIGHT_WIDGET_TABLE_COLUMNS',
  COUNTS_VEHICLEGROSSCOUNTWEIGHT_WIDGET_TABLE_FILTERS = 'COUNTS_VEHICLEGROSSCOUNTWEIGHT_WIDGET_TABLE_FILTERS',
  COUNTS_VEHICLEAXLECOUNT_WIDGET_TABLE_FILTERS = 'COUNTS_VEHICLEAXLECOUNT_WIDGET_TABLE_FILTERS',
  COUNTS_VEHICLEAXLECOUNT_WIDGET_TABLE_COLUMNS = 'COUNTS_VEHICLEAXLECOUNT_WIDGET_TABLE_COLUMNS',
  COUNTS_VEHICLEAXLECOUNTWEIGHT_WIDGET_TABLE_COLUMNS = 'COUNTS_VEHICLEAXLECOUNTWEIGHT_WIDGET_TABLE_COLUMNS',
  COUNTS_VEHICLEAXLECOUNTWEIGHT_WIDGET_TABLE_FILTERS = 'COUNTS_VEHICLEAXLECOUNTWEIGHT_WIDGET_TABLE_FILTERS',
  USER_AVATAR = 'USER_AVATAR',
  PERFORMANCE_REPORT_WIDGET_TABLE_COLUMNS = 'PERFORMANCE_REPORT_WIDGET_TABLE_COLUMNS',
  EVENT_REVIEW_TABLE_COLUMNS = 'EVENT_REVIEW_TABLE_COLUMNS',
  EVENT_REVIEW_TABLE_FILTERS = 'EVENT_REVIEW_TABLE_FILTERS',
  EVENT_REVIEW_LIST = 'EVENT_REVIEW_LIST',
  NOTIFICATION_TABLE_COLUMNS = 'NOTIFICATION_TABLE_COLUMNS',
  SPEED_WIDGET_TABLE_COLUMNS = 'SPEED_WIDGET_TABLE_COLUMNS',
  SPEED_WIDGET_TABLE_COLUMNS_FILTERS = 'SPEED_WIDGET_TABLE_COLUMNS_FILTERS',
  SIGN_MULTI_POST_MESSAGE_TABLE_COLUMNS = 'SIGN_MULTI_POST_MESSAGE_TABLE_COLUMNS',
  SIGN_MULTI_POST_MESSAGE_TABLE_FILTERS = 'SIGN_MULTI_POST_MESSAGE_TABLE_FILTERS',
  SIGN_MESSAGE_TABLE_COLUMNS = 'SIGN_MESSAGE_TABLE_COLUMNS',
  SIGN_MESSAGE_TABLE_FILTERS = 'SIGN_MESSAGE_TABLE_FILTERS',
  SIGN_HISTORY_TABLE_COLUMNS = 'SIGN_HISTORY_MESSAGE_TABLE_COLUMNS',
  SIGN_HISTORY_TABLE_FILTERS = 'SIGN_HISTORY_MESSAGE_TABLE_FILTERS',
  SIGN_LIBRARY_DISPLAY_TYPE_TABLE_COLUMNS = 'SIGN_LIBRARY_DISPLAY_TYPE_TABLE_COLUMNS',
  SIGN_LIBRARY_DISPLAY_TYPE_TABLE_FILTERS = 'SIGN_LIBRARY_DISPLAY_TYPE_TABLE_FILTERS',
  SIGN_LIBRARY_TABLE_COLUMNS = 'SIGN_LIBRARY_TABLE_COLUMNS',
  SIGN_LIBRARY_TABLE_FILTERS = 'SIGN_LIBRARY_TABLE_FILTERS',
  SIGN_GROUP_TABLE_COLUMNS = 'SIGN_GROUP_TABLE_COLUMNS',
  SIGN_GROUP_TABLE_FILTERS = 'SIGN_GROUP_TABLE_FILTERS',
  SIGN_ALARMS_TABLE_COLUMNS = 'SIGN_ALARMS_TABLE_COLUMNS',
  SIGN_ALARMS_TABLE_FILTERS = 'SIGN_ALARMS_TABLE_FILTERS',
  SIGN_STATUS_LOG_TABLE_COLUMNS = 'SIGN_STATUS_LOG_TABLE_COLUMNS',
  SIGN_STATUS_LOG_TABLE_FILTERS = 'SIGN_STATUS_LOG_TABLE_FILTERS',
  SIGN_LOG_TABLE_COLUMNS = 'SIGN_LOG_TABLE_COLUMNS',
  SIGN_LOG_TABLE_FILTERS = 'SIGN_LOG_TABLE_FILTERS',
  SIGN_RULE_TABLE_COLUMNS = 'SIGN_RULE_TABLE_COLUMNS',
  SIGN_RULE_TABLE_FILTERS = 'SIGN_RULE_TABLE_FILTERS',
  EVENT_SIGN_RESPONSE_TABLE_COLUMNS = 'EVENT_SIGN_RESPONSE_TABLE_COLUMNS',
  EVENT_SIGN_RESPONSE_TABLE_FILTERS = 'EVENT_SIGN_RESPONSE_TABLE_FILTERS',
  EVENT_DISPATCH_DRIVERS_COLUMNS = 'EVENT_DISPATCH_DRIVERS_COLUMNS',
  EVENT_DISPATCH_DRIVERS_FILTERS = 'EVENT_DISPATCH_DRIVERS_FILTERS',
  SIGNAL_CORRIDORS_TABLE_COLUMNS = 'SIGNAL_CORRIDORS_TABLE_COLUMNS',
  SIGNAL_CORRIDORS_TABLE_FILTERS = 'SIGNAL_CORRIDORS_TABLE_FILTERS',
  SIGNAL_ACTION_SETS_TABLE_COLUMNS = 'SIGNAL_ACTION_SETS_TABLE_COLUMNS',
  SIGNAL_ACTION_SETS_TABLE_FILTERS = 'SIGNAL_ACTION_SETS_TABLE_FILTERS',
  SIGNALS_ALARM_CONFIG_TABLE_COLUMNS = 'SIGNALS_ALARM_CONFIG_TABLE_COLUMNS',
  SIGNALS_ALARM_CONFIG_TABLE_FILTERS = 'SIGNALS_ALARM_CONFIG_TABLE_FILTERS',
  MAP_SEARCH_HISTORY = 'MAP_SEARCH_HISTORYS',
  MAP_ACCESS_TOKEN = 'MAP_ACCESS_TOKEN',
  SIGNAL_CORRIDORS_LEGS_TABLE_COLUMNS = 'SIGNAL_CORRIDORS_LEGS_TABLE_COLUMNS',
  SIGNAL_CORRIDORS_LEGS_TABLE_FILTERS = 'SIGNAL_CORRIDORS_LEGS_TABLE_FILTERS',
  SIGNAL_CORRIDORS_LINKS_TABLE_COLUMNS = 'SIGNAL_CORRIDORS_LINKS_TABLE_COLUMNS',
  SIGNAL_CORRIDORS_LINKS_TABLE_FILTERS = 'SIGNAL_CORRIDORS_LINKS_TABLE_FILTERS',
  INTERSECTION_TEMPLATE_TABLE_COLUMNS = 'INTERSECTION_TEMPLATE_TABLE_COLUMNS',
  INTERSECTION_TEMPLATE_TABLE_FILTERS = 'INTERSECTION_TEMPLATE_TABLE_FILTERS',
  SIGNAL_ACTIVITY_LOG_TABLE_COLUMNS = 'SIGNAL_ACTIVITY_LOG_TABLE_COLUMNS',
  SIGNAL_ACTIVITY_LOG_TABLE_FILTERS = 'SIGNAL_ACTIVITY_LOG_TABLE_FILTERS',
  ASSOCIATE_EVENTS_DETECTION_TABLE_FILTERS = 'ASSOCIATE_EVENTS_DETECTION_TABLE_FILTERS',
  ASSOCIATED_EVENTS_DETECTIONS_TABLE_FILTERS = 'ASSOCIATED_EVENTS_DETECTIONS_TABLE_FILTERS',
  TOLLING_ACTIVITY_LOG_TABLE_COLUMNS = 'TOLLING_ACTIVITY_LOG_TABLE_COLUMNS',
  TOLLING_ACTIVITY_LOG_TABLE_FILTERS = 'TOLLING_ACTIVITY_LOG_TABLE_FILTERS',
  TOLLING_ALARMS_TABLE_COLUMNS = 'TOLLING_ALARMS_TABLE_COLUMNS',
  TOLLING_ALARMS_TABLE_FILTERS = 'TOLLING_ALARMS_TABLE_FILTERS',
  TOLLING_PRICING_TABLE_COLUMNS = 'TOLLING_PRICING_TABLE_COLUMNS',
  TOLLING_PRICING_TABLE_FILTERS = 'TOLLING_PRICING_TABLE_FILTERS',
  TOLLING_SEGMENT_SIGN_TABLE_COLUMNS = 'TOLLING_SEGMENT_SIGN_TABLE_COLUMNS',
  TOLLING_SEGMENT_SIGN_TABLE_FILTERS = 'TOLLING_SEGMENT_SIGN_TABLE_FILTERS',
  TOLLING_ALARM_CONFIG_TABLE_COLUMNS = 'TOLLING_ALARM_CONFIG_TABLE_COLUMNS',
  TOLLING_ALARM_CONFIG_TABLE_FILTERS = 'TOLLING_ALARM_CONFIG_TABLE_FILTERS',
  TOLLING_POINT_GROUP_TABLE_COLUMNS = 'TOLLING_POINT_GROUP_TABLE_COLUMNS',
  TOLLING_POINT_GROUP_TABLE_FILTERS = 'TOLLING_POINT_GROUP_TABLE_FILTERS',
  TRAVEL_TIME_ACTIVITY_LOG_TABLE_COLUMNS = 'TRAVEL_TIME_ACTIVITY_LOG_TABLE_COLUMNS',
  TRAVEL_TIME_ACTIVITY_LOG_TABLE_FILTERS = 'TRAVEL_TIME_ACTIVITY_LOG_TABLE_FILTERS',
  TRAVEL_TIME_DETAILS_ACTIVITY_LOG_TABLE_FILTERS = 'TRAVEL_TIME_DETAILS_ACTIVITY_LOG_TABLE_FILTERS',
  TRAVEL_TIME_ALARMS_TABLE_FILTERS = 'TRAVEL_TIME_ALARMS_TABLE_FILTERS',
  TRAVEL_TIME_ALARMS_TABLE_COLUMNS = 'TRAVEL_TIME_ALARMS_TABLE_COLUMNS',
  WEATHER_STATIONS_ACTIVITY_LOG_TABLE_COLUMNS = 'WEATHER_STATIONS_ACTIVITY_LOG_TABLE_COLUMNS',
  WEATHER_STATIONS_ACTIVITY_LOG_TABLE_FILTERS = 'WEATHER_STATIONS_ACTIVITY_LOG_TABLE_FILTERS',
  WEATHER_STATIONS_DETAILS_ACTIVITY_LOG_TABLE_COLUMNS = 'WEATHER_STATIONS_DETAILS_ACTIVITY_LOG_TABLE_COLUMNS',
  WEATHER_STATIONS_DETAILS_ACTIVITY_LOG_TABLE_FILTERS = 'WEATHER_STATIONS_DETAILS_ACTIVITY_LOG_TABLE_FILTERS',
  SYSTEM_ACTIVITY_LOG_TABLE_COLUMNS = 'SYSTEM_ACTIVITY_LOG_TABLE_COLUMNS',
  SYSTEM_ACTIVITY_LOG_TABLE_FILTERS = 'SYSTEM_ACTIVITY_LOG_TABLE_FILTERS',
  SIGNAL_ALARMS_TABLE_COLUMNS = 'SIGNAL_ALARMS_TABLE_COLUMNS',
  SIGNAL_DETECTOR_GROUP_DETAILS_ACTIVITY_LOG_TABLE_COLUMNS = 'SIGNAL_DETECTOR_GROUP_DETAILS_ACTIVITY_LOG_TABLE_COLUMNS',
  SIGNAL_DETECTOR_GROUP_DETAILS_ACTIVITY_LOG_TABLE_FILTERS = 'SIGNAL_DETECTOR_GROUP_DETAILS_ACTIVITY_LOG_TABLE_FILTERS',
  SIGNAL_ALARMS_TABLE_FILTERS = 'SIGNAL_ALARMS_TABLE_FILTERS',
  ASSOCIATE_EVENTS_COMM_LOGS_TABLE_FILTERS = 'ASSOCIATE_EVENTS_COMM_LOGS_TABLE_FILTERS',
  TIMEZONE = 'TIMEZONE',
  TIME_SPACE_DIAGRAM_CONFIGS = 'TIME_SPACE_DIAGRAM_CONFIGS',
  SIGNAL_DETECTOR_GROUPS_TABLE_COLUMNS = 'SIGNAL_DETECTOR_GROUPS_TABLE_COLUMNS',
  SIGNAL_DETECTOR_GROUPS_TABLE_FILTERS = 'SIGNAL_DETECTOR_GROUPS_TABLE_FILTERS',
  SIGNAL_TRAFFIC_RESPONSIVE_PLANS_TABLE_COLUMNS = 'SIGNAL_TRAFFIC_RESPONSIVE_PLANS_TABLE_COLUMNS',
  SIGNAL_TRAFFIC_RESPONSIVE_PLANS_TABLE_FILTERS = 'SIGNAL_TRAFFIC_RESPONSIVE_PLANS_TABLE_FILTERS',
  SIGNAL_INTERSECTION_DETAIL_ACTIVITY_LOG_TABLE_COLUMNS = 'SIGNAL_INTERSECTION_DETAIL_ACTIVITY_LOG_TABLE_COLUMNS',
  SIGNAL_INTERSECTION_DETAIL_ACTIVITY_LOG_TABLE_FILTERS = 'SIGNAL_INTERSECTION_DETAIL_ACTIVITY_LOG_TABLE_FILTERS',
  MAP_CONFIG_SESSION_KEY = 'mapConfig',
  SCHEDULED_EVENTS_TABLE_COLUMNS = 'SCHEDULED_EVENTS_TABLE_COLUMNS',
  SCHEDULED_EVENTS_TABLE_FILTERS = 'SCHEDULED_EVENTS_TABLE_FILTERS',
  SIGNAL_DATABASE_CHANGE_LOGS_TABLE_COLUMNS = 'SIGNAL_DATABASE_CHANGE_LOGS_TABLE_COLUMNS',
  SIGNAL_DATABASE_CHANGE_LOGS_TABLE_FILTERS = 'SIGNAL_DATABASE_CHANGE_LOGS_TABLE_FILTERS',
  HISTORICAL_ALARMS_REPORT_COLUMNS = 'HISTORICAL_ALARMS_REPORT_COLUMNS',
  HISTORICAL_ALARMS_REPORT_FILTERS = 'HISTORICAL_ALARMS_REPORT_FILTERS',
  DATABASE_EXPORT_TEMPLATES_COLUMNS = 'DATABASE_EXPORT_TEMPLATES_COLUMNS',
  TRAFFIC_RESPONSIVE_APPLIED_COMMANDS_FILTERS = 'TRAFFIC_RESPONSIVE_APPLIED_COMMANDS_FILTERS',
  TRAFFIC_RESPONSIVE_APPLIED_COMMANDS_COLUMNS = 'TRAFFIC_RESPONSIVE_APPLIED_COMMANDS_COLUMNS',
  ACTION_CONTROL_LOG_FILTERS = 'ACTION_CONTROL_LOG_FILTERS',
  ACTION_CONTROL_LOG_COLUMNS = 'ACTION_CONTROL_LOG_COLUMNS',
  DATABASE_EXPORT_TEMPLATES_FILTERS = 'DATABASE_EXPORT_TEMPLATES_FILTERS',
  JOYSTICK_HOTKEYS = 'JOYSTICK_HOTKEYS',
  JOYSTICK_HOTKEYS_MAPPING = 'JOYSTICK_HOTKEYS_MAPPING',
  CONNECTED_VEHICLES_LIST_TABLE_COLUMNS = 'CONNECTED_VEHICLES_LIST_TABLE_COLUMNS',
  CONNECTED_VEHICLES_LIST_TABLE_FILTERS = 'CONNECTED_VEHICLES_LIST_TABLE_FILTERS',
  CONNECTED_VEHICLES_ALARMS_TABLE_COLUMNS = 'CONNECTED_VEHICLES_ALARMS_TABLE_COLUMNS',
  CONNECTED_VEHICLES_ALARMS_TABLE_FILTERS = 'CONNECTED_VEHICLES_ALARMS_TABLE_FILTERS',
  CONNECTED_VEHICLES_ACTIVITY_LOG_TABLE_COLUMNS = 'CONNECTED_VEHICLES_ACTIVITY_LOG_TABLE_COLUMNS',
  CONNECTED_VEHICLES_ACTIVITY_LOG_TABLE_FILTERS = 'CONNECTED_VEHICLES_ACTIVITY_LOG_TABLE_FILTERS',
  ASSET_ACTIVITY_LOG_TABLE_COLUMNS = 'ASSET_ACTIVITY_LOG_TABLE_COLUMNS',
  ASSET_ACTIVITY_LOG_TABLE_FILTERS = 'ASSET_ACTIVITY_LOG_TABLE_FILTERS',
  ASSET_MANAGEMENT_INVENTORY_TABLE_FILTERS = 'ASSET_MANAGEMENT_INVENTORY_TABLE_FILTERS',
  ASSET_MANAGEMENT_INVENTORY_TABLE_COLUMNS = 'ASSET_MANAGEMENT_INVENTORY_TABLE_COLUMNS',
  CONNECTED_VEHICLES_DETAILS_ACTIVITY_LOG_TABLE_COLUMNS = 'CONNECTED_VEHICLES_DETAILS_ACTIVITY_LOG_TABLE_COLUMNS',
  CONNECTED_VEHICLES_DETAILS_ACTIVITY_LOG_TABLE_FILTERS = 'CONNECTED_VEHICLES_DETAILS_ACTIVITY_LOG_TABLE_FILTERS',
  ASSET_MANAGEMENT_WORK_ORDER_TABLE_COLUMNS = 'ASSET_MANAGEMENT_WORK_ORDER_TABLE_COLUMNS',
  ASSET_MANAGEMENT_WORK_ORDER_TABLE_FILTERS = 'ASSET_MANAGEMENT_WORK_ORDER_TABLE_FILTERS',
  ASSET_MANAGEMENT_WORK_ORDER_TRANSACTION_TABLE_FILTERS = 'ASSET_MANAGEMENT_WORK_ORDER_TRANSACTION_TABLE_FILTERS',
  ASSET_MANAGEMENT_CHILD_ASSETS_TABLE_COLUMNS = 'ASSET_MANAGEMENT_CHILD_ASSETS_TABLE_COLUMNS',
  ASSET_MANAGEMENT_CHILD_ASSETS_TABLE_FILTERS = 'ASSET_MANAGEMENT_CHILD_ASSETS_TABLE_FILTERS',
  ASSET_MANAGEMENT_TRANSACTIONS_TABLE_COLUMNS = 'ASSET_MANAGEMENT_TRANSACTIONS_TABLE_COLUMNS',
  ASSET_MANAGEMENT_TRANSACTIONS_TABLE_FILTERS = 'ASSET_MANAGEMENT_TRANSACTIONS_TABLE_FILTERS',
  ASSET_MANAGEMENT_WORK_ORDER_CONFIGURATIONS_TABLE_COLUMNS = 'ASSET_MANAGEMENT_WORK_ORDER_CONFIGURATIONS_TABLE_COLUMNS',
  ASSET_MANAGEMENT_WORK_ORDER_CONFIGURATIONS_TABLE_FILTERS = 'ASSET_MANAGEMENT_WORK_ORDER_CONFIGURATIONS_TABLE_FILTERS',
  ASSET_MANAGEMENT_WORK_ORDER_TRACKING_TABLE_FILTERS = 'ASSET_MANAGEMENT_WORK_ORDER_TRACKING_TABLE_FILTERS',
  ASSET_MANAGEMENT_INVENTORY_DETAILS_WORK_ORDER_TABLE_COLUMNS = 'ASSET_MANAGEMENT_INVENTORY_DETAILS_WORK_ORDER_TABLE_COLUMNS',
  ASSET_MANAGEMENT_INVENTORY_DETAILS_WORK_ORDER_TABLE_FILTERS = 'ASSET_MANAGEMENT_INVENTORY_DETAILS_WORK_ORDER_TABLE_FILTERS',
  EVENT_ROADWAY_CONDITION_COLUMNS = 'EVENT_ROADWAY_CONDITION_COLUMNS',
  ROAD_CONDITIONS_TABLE_VIEW = 'ROAD_CONDITIONS_TABLE_VIEW',
  NETWORK_CONDITION_TABLE_COLUMNS = 'NETWORK_CONDITION_TABLE_COLUMNS',
  NETWORK_CONDITION_TABLE_FILTERS = 'NETWORK_CONDITION_TABLE_FILTERS',
  BOUNDED_ROUTE_TABLE_FILTERS = 'BOUNDED_ROUTE_TABLE_FILTERS',
  NETWORK_JURISDICTION_TABLE_COLUMNS = 'NETWORK_JURISDICTION_TABLE_COLUMNS',
  NETWORK_JURISDICTION_TABLE_FILTERS = 'NETWORK_JURISDICTION_TABLE_FILTERS',
  LOCATIONS_TREE_TABLE_COLUMNS = 'LOCATIONS_TREE_TABLE_COLUMNS',
  LOCATIONS_TREE_TABLE_FILTERS = 'LOCATIONS_TREE_TABLE_FILTERS',
  RAMP_METER_LIST_TABLE_COLUMNS = 'RAMP_METER_LIST_TABLE_COLUMNS',
  RAMP_METER_LIST_TABLE_FILTERS = 'RAMP_METER_LIST_TABLE_FILTERS',
  RAMP_METER_ACTIVITY_LOG_TABLE_COLUMNS = 'RAMP_METER_ACTIVITY_LOG_TABLE_COLUMNS',
  RAMP_METER_ACTIVITY_LOG_TABLE_FILTERS = 'RAMP_METER_ACTIVITY_LOG_TABLE_FILTERS',
  RAMP_METER_SYSTEM_DATABASES_TABLE_COLUMNS = 'RAMP_METER_SYSTEM_DATABASES_TABLE_COLUMNS',
  RAMP_METER_SYSTEM_DATABASES_TABLE_FILTERS = 'RAMP_METER_SYSTEM_DATABASES_TABLE_FILTERS',
  RAMP_METER_DRAFT_DATABASES_TABLE_COLUMNS = 'RAMP_METER_DRAFT_DATABASES_TABLE_COLUMNS',
  RAMP_METER_DRAFT_DATABASES_TABLE_FILTERS = 'RAMP_METER_DRAFT_DATABASES_TABLE_FILTERS',
  RAMP_METER_DATABASE_CHANGE_LOGS_TABLE_COLUMNS = 'RAMP_METER_DATABASE_CHANGE_LOGS_TABLE_COLUMNS',
  RAMP_METER_DATABASE_CHANGE_LOGS_TABLE_FILTERS = 'RAMP_METER_DATABASE_CHANGE_LOGS_TABLE_FILTERS',
  FILE_MANAGER_ACTIVITY_LOG_TABLE_COLUMNS = 'FILE_MANAGER_ACTIVITY_LOG_TABLE_COLUMNS',
  FILE_MANAGER_ACTIVITY_LOG_TABLE_FILTERS = 'FILE_MANAGER_ACTIVITY_LOG_TABLE_FILTERS',
  COUNTS_EMAIL_NOTIFICATIONS_TABLE_FILTERS = 'COUNTS_EMAIL_NOTIFICATIONS_TABLE_FILTERS',
  APP_SEARCH_HISTORY = 'APP_SEARCH_HISTORY',
  SIGNALS_EVENT_TIMELINE_REPORT_TABLE_FILTERS = 'SIGNALS_EVENT_TIMELINE_REPORT_TABLE_FILTERS',
  RAMP_METER_APPLIED_COMMANDS_TABLE_COLUMNS = 'RAMP_METER_APPLIED_COMMANDS_TABLE_COLUMNS',
  RAMP_METER_APPLIED_COMMANDS_TABLE_FILTERS = 'RAMP_METER_APPLIED_COMMANDS_TABLE_FILTERS',
  RAMP_METER_ACTIVITY_LOG_PAGE_TABLE_COLUMNS = 'RAMP_METER_ACTIVITY_LOG_PAGE_TABLE_COLUMNS',
  RAMP_METER_ACTIVITY_LOG_PAGE_TABLE_FILTERS = 'RAMP_METER_ACTIVITY_LOG_PAGE_TABLE_FILTERS',
  SIGNALS_DASHBOARD = 'SIGNALS_DASHBOARD',
  WORK_ORDER_SYSTEM = 'WORK_ORDER_SYSTEM',
  TRANSIT_ROUTES_LIST_TABLE_COLUMNS = 'TRANSIT_ROUTES_LIST_TABLE_COLUMNS',
  TRANSIT_ROUTES_LIST_TABLE_FILTERS = 'TRANSIT_ROUTES_LIST_TABLE_FILTERS',
  VIDEO_ALARMS_TABLE_COLUMNS = 'VIDEO_ALARMS_TABLE_COLUMNS',
  VIDEO_ALARMS_TABLE_FILTERS = 'VIDEO_ALARMS_TABLE_FILTERS',
  VIDEO_ACTIVITY_LOG_TABLE_COLUMNS = 'VIDEO_ACTIVITY_LOG_TABLE_COLUMNS',
  VIDEO_ACTIVITY_LOG_TABLE_FILTERS = 'VIDEO_ACTIVITY_LOG_TABLE_FILTERS',
  EVENTS_ACTIVITY_LOG_TABLE_COLUMNS = 'EVENTS_ACTIVITY_LOG_TABLE_COLUMNS',
  DETECTOR_ALARMS_TABLE_COLUMNS = 'DETECTOR_ALARMS_TABLE_COLUMNS',
  DETECTOR_ALARMS_TABLE_FILTERS = 'DETECTOR_ALARMS_TABLE_FILTERS',
  VIDEO_ALARM_CONFIGS_TABLE_COLUMNS = 'VIDEO_ALARM_CONFIGS_TABLE_COLUMNS',
  VIDEO_ALARM_CONFIGS_TABLE_FILTERS = 'VIDEO_ALARM_CONFIGS_TABLE_FILTERS',
  CONNECT_VEHICLES_ALARM_CONFIGS_TABLE_COLUMNS = 'CONNECT_VEHICLES_ALARM_CONFIGS_TABLE_COLUMNS',
  CONNECT_VEHICLES_ALARM_CONFIGS_TABLE_FILTERS = 'CONNECT_VEHICLES_ALARM_CONFIGS_TABLE_FILTERS',
  TRAVEL_TIME_ALARM_CONFIGS_TABLE_COLUMNS = 'TRAVEL_TIME_ALARM_CONFIGS_TABLE_COLUMNS',
  TRAVEL_TIME_ALARM_CONFIGS_TABLE_FILTERS = 'TRAVEL_TIME_ALARM_CONFIGS_TABLE_FILTERS',
  COUNTS_ALARM_CONFIGS_TABLE_FILTERS = 'COUNTS_ALARM_CONFIGS_TABLE_FILTERS',
  COUNTS_ALARM_CONFIGS_TABLE_COLUMNS = 'COUNTS_ALARM_CONFIGS_TABLE_COLUMNS',
  SITES_TABLE_COLUMNS = 'SITES_TABLE_COLUMNS',
  SITES_TABLE_FILTERS = 'SITES_TABLE_FILTERS',
  TOLL_POINTS_TABLE_FILTERS = 'TOLLING_POINTS_TABLE_FILTERS',
  TOLL_POINTS_TABLE_COLUMNS = 'TOLLING_POINTS_TABLE_COLUMNS',
  TOLL_ROADS_TABLE_FILTERS = 'TOLLING_ROADS_TABLE_FILTERS',
  TOLL_ROADS_TABLE_COLUMNS = 'TOLLING_ROADS_TABLE_COLUMNS',
  TOLL_POINTS_ACTIVITY_LOG_TABLE_FILTERS = 'TOLL_POINTS_ACTIVITY_LOG_TABLE_FILTERS',
  TOLL_POINTS_ACTIVITY_LOG_TABLE_COLUMNS = 'TOLL_POINTS_ACTIVITY_LOG_TABLE_COLUMNS',
  TOLL_POINTS_DOCUMENTS_TABLE_FILTERS = 'TOLL_POINTS_DOCUMENTS_TABLE_FILTERS',
  TOLL_POINTS_DOCUMENTS_TABLE_COLUMNS = 'TOLL_POINTS_DOCUMENTS_TABLE_COLUMNS',
  TOLL_SEGMENT_SIGNS_TABLE_FILTERS = 'TOLL_SEGMENT_SIGNS_TABLE_FILTERS',
  TOLL_SEGMENT_SIGNS_TABLE_COLUMNS = 'TOLL_SEGMENT_SIGNS_TABLE_COLUMNS',
  TOLL_SEGMENT_DOCUMENTS_TABLE_FILTERS = 'TOLL_SEGMENT_DOCUMENTS_TABLE_FILTERS',
  TOLL_SEGMENT_DOCUMENTS_TABLE_COLUMNS = 'TOLL_SEGMENT_DOCUMENTS_TABLE_COLUMNS',
  TOLL_SEGMENT_ACTIVITY_LOG_TABLE_FILTERS = 'TOLL_SEGMENT_ACTIVITY_LOG_TABLE_FILTERS',
  TOLL_SEGMENT_ACTIVITY_LOG_TABLE_COLUMNS = 'TOLL_SEGMENT_ACTIVITY_LOG_TABLE_COLUMNS',
  TOLL_SEGMENT_TABLE_FILTERS = 'TOLL_SEGMENT_TABLE_FILTERS',
  TOLL_SEGMENT_TABLE_COLUMNS = 'TOLL_SEGMENT_TABLE_COLUMNS',
  TOLL_SEGMENT_DETECTORS_TABLE_FILTERS = 'TOLL_SEGMENT_DETECTORS_TABLE_FILTERS',
  TOLL_SEGMENT_DETECTORS_TABLE_COLUMNS = 'TOLL_SEGMENT_DETECTORS_TABLE_COLUMNS',
  TOLLING_PRICING_CURRENT_RATE_TABLE_FILTERS = 'TOLLING_PRICING_CURRENT_RATE_TABLE_FILTERS',
  TOLLING_PRICING_CURRENT_RATE_TABLE_COLUMNS = 'TOLLING_PRICING_CURRENT_RATE_TABLE_COLUMNS',
  TOLLING_PRICING_RATE_HISTORY_TABLE_FILTERS = 'TOLLING_PRICING_RATE_HISTORY_TABLE_FILTERS',
  TOLLING_PRICING_RATE_HISTORY_TABLE_COLUMNS = 'TOLLING_PRICING_RATE_HISTORY_TABLE_COLUMNS',
  TOLLING_PRICING_HISTORICAL_RATE_TABLE_FILTERS = 'TOLLING_PRICING_HISTORICAL_RATE_TABLE_FILTERS',
  TOLLING_PRICING_HISTORICAL_RATE_TABLE_COLUMNS = 'TOLLING_PRICING_HISTORICAL_RATE_TABLE_COLUMNS',
  TOLLING_PRICING_ACTIVITY_TABLE_FILTERS = 'TOLLING_PRICING_ACTIVITY_TABLE_FILTERS',
  TOLLING_PRICING_ACTIVITY_TABLE_COLUMNS = 'TOLLING_PRICING_ACTIVITY_TABLE_COLUMNS',
  TOLLING_PRICING_HISTORICAL_RATE_HISTORY_TABLE_COLUMNS = 'TOLLING_PRICING_HISTORICAL_RATE_HISTORY_TABLE_COLUMNS',
  TOLLING_PRICING_HISTORICAL_RATE_HISTORY_TABLE_FILTERS = 'TOLLING_PRICING_HISTORICAL_RATE_HISTORY_TABLE_FILTERS',
  TOLLING_PRICING_CONFIRMED_RATE_HISTORY_TABLE_COLUMNS = 'TOLLING_PRICING_CONFIRMED_RATE_HISTORY_TABLE_COLUMNS',
  TOLLING_PRICING_CONFIRMED_RATE_HISTORY_TABLE_FILTERS = 'TOLLING_PRICING_CONFIRMED_RATE_HISTORY_TABLE_FILTERS',
  TUNNEL_FAN_ALARMS_TABLE_COLUMNS = 'TUNNEL_FAN_ALARMS_TABLE_COLUMNS',
  TUNNEL_FAN_ALARMS_TABLE_FILTERS = 'TUNNEL_FAN_ALARMS_TABLE_FILTERS',
  GATE_REVERSE_DETECTOR_TABLE_FILTERS = 'GATE_REVERSE_DETECTOR_TABLE_FILTERS',
  GATE_REVERSE_DETECTOR_TABLE_COLUMNS = 'GATE_REVERSE_DETECTOR_TABLE_COLUMNS',
  DEBUG_COLUMNS = 'DEBUG_COLUMNS',
  DEBUG_FILTERS = 'DEBUG_FILTERS',
  SELECT_SIGNALS_ACTION_COLUMNS = 'SELECT_SIGNALS_ACTION_COLUMNS',
  SELECT_SIGNALS_ACTION_FILTERS = 'SELECT_SIGNALS_ACTION_FILTERS',
  CORRIDOR_ACTIVITY_COLUMNS = 'CORRIDOR_ACTIVITY_COLUMNS',
  CORRIDOR_ACTIVITY_FILTERS = 'CORRIDOR_ACTIVITY_FILTERS',
}

export interface PreferenceState<T> {
  key: string;
  loading: boolean;
  preference: T | undefined;
  error: ApolloError | undefined;
}

export interface PreferenceMutation<T> {
  savePreference: (value: T) => Promise<any>;
  clearPreference: () => void;
  savePreferenceResult?: MutationResult<any>;
}

export type usePreferenceData<T> = [PreferenceState<T>, PreferenceMutation<T>];
